import { render, staticRenderFns } from "./historyList.vue?vue&type=template&id=0ce83d93&scoped=true"
import script from "./historyList.vue?vue&type=script&lang=js"
export * from "./historyList.vue?vue&type=script&lang=js"
import style0 from "./historyList.vue?vue&type=style&index=0&id=0ce83d93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce83d93",
  null
  
)

export default component.exports